import React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import ProfileHeader from "../ProfileHeader";
import { Link } from "react-router-dom";
import { openChangePasswordModal } from "../../../../../store/onboarding/cases/actions";
import { getNotificationSettings } from "../../../../../store/notifications/actions";
import { useIntl } from "react-intl";
import { openEditProfileModal } from "../../../../../store/auth/actions";

type PropsFromState = {
  isLoading: {
    loadUserInfo: boolean;
  };
};

type DispatchProps = {
  openChangePasswordModal: () => any;
  getNotificationSettings: () => any;
  openEditProfileModal: () => any;
};

type Props = PropsFromState & DispatchProps;

const ProfileTab = (props: Props) => {
  const handleChangePassword = () => {
    props.openChangePasswordModal();
  };

  const intl = useIntl();

  return (
    <div className="dataContainer">
      <ProfileHeader />
      <div className="mt-3 d-flex justify-content-center">
        <div className="profileHelpfulLinks">
          <button 
            className="blueBtnMd mb-3" 
            onClick={props.openEditProfileModal} 
            > 
            {intl.formatMessage({ 
              id: "app.dashboard.profile.editProfileBtn.label", 
            })} 
          </button> 
          <div className="blueBtnMd w-100 mb-3" onClick={handleChangePassword}>
            {intl.formatMessage({
              id: "app.dashboard.profile.changePasswordBtn.label",
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ auth }: ApplicationState): PropsFromState => {
  return {
    isLoading: {
      loadUserInfo: auth.isLoading.loadUserInfo,
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      openChangePasswordModal: openChangePasswordModal,
      getNotificationSettings: getNotificationSettings,
      openEditProfileModal: openEditProfileModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProfileTab);
